import { render, staticRenderFns } from "./creatMessage.vue?vue&type=template&id=06c9e50d&scoped=true&"
import script from "./creatMessage.vue?vue&type=script&lang=ts&"
export * from "./creatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./creatMessage.vue?vue&type=style&index=0&id=06c9e50d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9e50d",
  null
  
)

export default component.exports